// import React from "react";
// import { useState, useEffect } from "react";
// import SkillCategories from "./SkillCategories";
// import CategoryDetails from "./CategoryDetails";
// import { dummyData } from "./data/skillsData";

// const DigitalSkilling = () => {
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [categories, setCategories] = useState([]);

//   useEffect(() => {
//     // Load data from our dummy JSON
//     setCategories(dummyData.categories);
//     // Set Digital Business as default selected category
//     setSelectedCategory(
//       dummyData.categories.find((cat) => cat.id === "digital-business")
//     );
//   }, []);

//   const handleCategorySelect = (category) => {
//     setSelectedCategory(category);
//   };

//   return (
//     <main className="min-h-screen bg-gray-50">
//       <div className="container mt-0 mx-auto px-4 py-8 max-w-6xl">
//         <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-10">
//           A single plan with unlimited digital skilling
//         </h1>

//         <div className="flex flex-col md:flex-row gap-6">
//           {/* Categories sidebar */}
//           <div className="w-full md:w-1/3 lg:w-1/4 border border-r-4 border-t-4 border-b-4 border-l-0 border-blue-200 rounded-3xl bg-white p-6 shadow-sm">
//             <SkillCategories
//               categories={categories}
//               selectedCategory={selectedCategory}
//               onSelectCategory={handleCategorySelect}
//             />
//           </div>

//           {/* Main content area */}
//           <div className="w-full md:w-2/3 lg:w-3/4">
//             {selectedCategory && (
//               <CategoryDetails category={selectedCategory} />
//             )}
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// };

// export default DigitalSkilling;
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const slugify = (text) =>
  text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");

const DigitalSkilling = () => {
  const { t } = useTranslation();
  const { categories, isLoading, error } = useSelector((state) => state?.category);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="text-center pt-28 pb-16 px-4">
        <h1 className="text-5xl sm:text-6xl font-extrabold text-gray-900 leading-tight">
          Learning Hub<span className="text-indigo-600">+</span>
        </h1>
        <p className="mt-4 text-xl sm:text-2xl text-gray-600 font-medium max-w-2xl mx-auto">
          A Single Plan with <span className="text-indigo-600 font-semibold">Unlimited Digital Skilling</span>
        </p>

        <div className="mt-8">
          <Link
            to="/skillup"
            className="inline-block bg-indigo-600 text-white px-8 py-3 rounded-full font-semibold shadow-md hover:bg-indigo-700 transition"
          >
            {t("Explore Roadmaps")}
          </Link>
        </div>
      </div>

      {/* Category Grid */}
      <div className="max-w-7xl mx-auto px-6 pb-16">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">
          {t("Featured Skill Tracks")}
        </h2>

        {isLoading && (
          <p className="text-blue-500 text-center animate-pulse">{t("Loading categories...")}</p>
        )}
        {error && (
          <p className="text-red-500 text-center">{t("Error loading categories")}: {error}</p>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {!isLoading &&
            !error &&
            Array.isArray(categories) &&
            categories.slice(0, 8).map((category, index) => (
              <Link
                key={index}
                to={`/categories/${slugify(category.categoryName)}/${category.id}`}
                state={{ category }}
                className="bg-white rounded-xl shadow hover:shadow-lg p-6 transition transform hover:-translate-y-1"
              >
                <h3 className="text-lg font-bold text-gray-800 mb-2">{category.categoryName}</h3>
                <p className="text-sm text-gray-600">
                  {category.categoryDescription || "Explore this path to start learning."}
                </p>
              </Link>
            ))}
        </div>
      </div>
    </div>
  );
};

export default DigitalSkilling;

